import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage id="login.forgot-password" defaultMessage="Forgot password?" />
);
